/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Banking_MethodInputs */

const en_clients_field_banking_method = /** @type {(inputs: Clients_Field_Banking_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const pt_br2_clients_field_banking_method = /** @type {(inputs: Clients_Field_Banking_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Clients_Field_Banking_MethodInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_banking_method = /** @type {((inputs?: Clients_Field_Banking_MethodInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Banking_MethodInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_banking_method(inputs)
	return pt_br2_clients_field_banking_method(inputs)
});